import React, { useState, useRef } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import {
    TableHead,
    TableRow,
    TableCell,
    Box,
} from "@mui/material";

const RoadMapTableHeader = ({ startDate, endDate, setSortOrder, setSortBy, sortBy, sortOrder, onSortChange, onSearchChange = () => { } }) => {
    const SORTABLE_COLUMNS = ["title", "owner", "category", "timeline", "status"];
    const debounceRef = useRef(null);
    const [columnSearch, setColumnSearch] = useState({
        "title": "",
        "owner": "",
        "category": "",
        "timeline": "",
        "status": ""
    })
    const formatDateLabel = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };


    const handleSort = (columnKey) => {
        if (!SORTABLE_COLUMNS.includes(columnKey)) return;

        const newOrder =
            sortBy === columnKey && sortOrder === "asc" ? "desc" : "asc";

        setSortBy(columnKey);
        setSortOrder(newOrder);
        onSortChange(columnKey, newOrder);
    };

    const renderSortIcon = (columnKey) => {
        if (!SORTABLE_COLUMNS.includes(columnKey)) return null;

        if (sortBy === columnKey) {
            return sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />;
        }
        return <ArrowUp size={12} style={{ opacity: 0.3 }} />;
    };

    const debouncedSearch = (key, value) => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            onSearchChange(key, value);
        }, 400);
    };

    const handleSearchChange = (key, value) => {
        setColumnSearch({
            title: "",
            owner: "",
            category: "",
            timeline:"",
            status: "",
            [key]: value,
        });
        debouncedSearch(key, value)
    };

    const renderSearchInput = (key) => (
        <input
            style={{
                width: "100%",
                height: "36px",
                fontSize: "12px",
                padding: "8px 10px",
                backgroundColor: "white",
                borderRadius: "4px",
                outline: "none",
                fontWeight: 400,
            }}
            placeholder="Search"
            value={columnSearch[key] || ""}
            onChange={(e) => handleSearchChange(key, e.target.value)}
            onClick={(e) => e.stopPropagation()}
        />
    );



    return (
        <>
            <TableHead sx={{ backgroundColor: "#F0FDFA", position: "sticky", top: 0, zIndex: 2, "& .MuiTableCell-head": { backgroundColor: "#F0FDFA" } }} >
                <TableRow>
                    <TableCell
                        onClick={() => handleSort("title")}
                        sx={{
                            width: 500,
                            cursor: "pointer",
                            p: "12px",
                            borderRight: "1px solid #E6EDF3",
                            borderBottom: "1px solid #E6EDF3",
                            background: "#F0FDFA",
                            whiteSpace: "nowrap",
                            color: "#404040",
                        }}
                    >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                            Feature
                            {renderSortIcon("title")}
                        </span>
                        <div>{renderSearchInput("title")}</div>
                    </TableCell>

                    <TableCell
                        onClick={() => handleSort("owner")}
                        sx={{
                            width: 500,
                            cursor: "pointer",
                            p: "12px",
                            borderRight: "1px solid #E6EDF3",
                            borderBottom: "1px solid #E6EDF3",
                            background: "#F0FDFA",
                            whiteSpace: "nowrap",
                            color: "#404040",
                        }}
                    >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                            Owner
                            {renderSortIcon("owner")}
                        </span>
                        <div>{renderSearchInput("owner")}</div>
                    </TableCell>

                    <TableCell
                        onClick={() => handleSort("category")}
                        sx={{
                            width: 140,
                            cursor: "pointer",
                            p: "12px",
                            borderRight: "1px solid #E6EDF3",
                            borderBottom: "1px solid #E6EDF3",
                            background: "#F0FDFA",
                            whiteSpace: "nowrap",
                            color: "#404040",
                        }}
                    >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                            Category
                            {renderSortIcon("category")}
                        </span>
                        <div>{renderSearchInput("category")}</div>
                    </TableCell>

                    <TableCell
                     onClick={() => handleSort("timeline")}
                        sx={{
                            cursor:"pointer",
                            width: 720,
                            p: "12px",
                            borderRight: "1px solid #E6EDF3",
                            borderBottom: "1px solid #E6EDF3",
                            background: "#F0FDFA",
                            color: "#404040",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: 13,
                                color: "#475569",
                                fontWeight: 500,
                            }}
                        >
                            <span  style={{ display: "inline-flex", alignItems: "center", gap: 4 }} >
                                Timeline
                                {renderSortIcon("timeline")}
                            </span>
                           

                        </Box>
                    </TableCell>

                    <TableCell
                        onClick={() => handleSort("status")}
                        sx={{
                            width: 120,
                            cursor: "pointer",
                            p: "12px",
                            borderLeft: "1px solid #E6EDF3",
                            borderBottom: "1px solid #E6EDF3",
                            background: "#F0FDFA",
                            whiteSpace: "nowrap",
                            color: "#404040",
                        }}
                    >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                            Progress
                            {renderSortIcon("status")}
                        </span>
                        <div>{renderSearchInput("status")}</div>
                    </TableCell>
                </TableRow>
            </TableHead>

        </>
    )
}

export default RoadMapTableHeader;